module.exports = __webpack_public_path__ + "static/img/apple-store-badge.a9afa07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/apple-store-badge.png
// module id = j2l7
// module chunks = 20